import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";
import { toast } from "react-toastify";

const HygienicTransportationStore = create((set, get) => ({
  hygienicReportData: [],
  loading: false,
  error: null,

  fetchHygienicTransportationReport: async (queryParams) => {
    set({ loading: true, error: null });

    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const hygienicDataReport = await apiCall({
        url: `${API_BASE_URL1}KpiReport/HygieneReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      const data = Array.isArray(hygienicDataReport)
        ? hygienicDataReport
        : [];

      // ================= CALCULATE TOTALS =================
      const totals = data.reduce(
        (acc, row) => ({
          hygieneTripCount:
            acc.hygieneTripCount + (Number(row.hygieneTripCount) || 0),
          tertiaryTripCount:
            acc.tertiaryTripCount + (Number(row.tertiaryTripCount) || 0),
          performanceAchievedPercentage:
            acc.performanceAchievedPercentage +
            (Number(row.performanceAchievedPercentage) || 0),
        }),
        {
          hygieneTripCount: 0,
          tertiaryTripCount: 0,
          performanceAchievedPercentage: 0,
        }
      );

      const totalRow = {
        tripDate: "Total",
        hygieneTripCount: totals.hygieneTripCount,
        tertiaryTripCount: totals.tertiaryTripCount,
        performanceAchievedPercentage:
          totals.performanceAchievedPercentage,
      };

      const finalData = data.length ? [...data, totalRow] : data;

      set({
        hygienicReportData: finalData,
        loading: false,
        error: null,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;


      // 🔐 401 Unauthorized
      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";

        set({
          hygienicReportData: [],
          error: "Unauthorized",
          loading: false,
        });
      }

      // ⚠️ 400 Bad Request
      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          hygienicReportData: [],
          error: message || "Bad Request",
          loading: false,
        });
      }

      // 📭 404 No Data
      else if (status === 404) {
        toast.error(error.message );
        set({
          hygienicReportData: [],
          error: "No Data found.",
          loading: false,
        });
      }

      // 🔴 500 Internal Server Error
      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          hygienicReportData: [],
          error: "Internal Server Error",
          loading: false,
        });
      }

      // ❓ Other Errors
      else {
        toast.error(message || "Something went wrong");
        set({
          hygienicReportData: [],
          error: message || "Something went wrong",
          loading: false,
        });
      }

    } finally {
      set({ loading: false });
    }
  },

}));

export default HygienicTransportationStore;
